import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/redux/store';

export const selectFocusScheduleSlice = (state: RootState) => state.focusSchedule;

export const selectVersionScheduling = createSelector(selectFocusScheduleSlice, (focusSchedule) => focusSchedule.versionScheduling);

export const selectVersionSchedulingRows = createSelector(selectVersionScheduling, (versionScheduling) => versionScheduling.rows);

export const selectIncrementalScheduling = createSelector(selectFocusScheduleSlice, (focusSchedule) => focusSchedule.incrementalScheduling);

export const selectIncrementalSchedulingsByVersionSchedulingId = createSelector(
  selectIncrementalScheduling,
  (_: RootState, versionSchedulingId: number) => versionSchedulingId,
  (incrementalScheduling, versionSchedulingId) => incrementalScheduling.byVersionSchedulingId[versionSchedulingId] ?? []
);

export const selectIncrementalSchedulingStatusByVersionSchedulingId = createSelector(
  selectIncrementalScheduling,
  (_: RootState, versionSchedulingId: number) => versionSchedulingId,
  (incrementalScheduling, versionSchedulingId) => incrementalScheduling.statusByVersionSchedulingId[versionSchedulingId] ?? 'idle'
);

export const selectIsIncrementalSchedulingLoadingByVersionSchedulingId = createSelector(
  selectIncrementalSchedulingStatusByVersionSchedulingId,
  (status) => status === 'loading'
);

export const selectIncrementalSchedulingDeleteStatusBySchedulingId = createSelector(
  selectIncrementalScheduling,
  (_: RootState, schedulingId: number) => schedulingId,
  (incrementalScheduling, schedulingId) => incrementalScheduling.deleteStatusBySchedulingId[schedulingId] ?? 'idle'
);

export const selectIsIncrementalSchedulingDeletingBySchedulingId = createSelector(
  selectIncrementalSchedulingDeleteStatusBySchedulingId,
  (status) => status === 'loading'
);
